import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ExemptionsComponent} from "../exemptions_component/exemptions.component";
import {Exemption} from "@portbase/bezoekschip-service-typescriptmodels";
import {attachmentRequired, getTooltipAttachment} from "../exemption_utils/exemption.utils";

@Component({
    selector: 'app-visit-exemptions-exemption-common',
    templateUrl: './exemption_common.component.html',
    styleUrls: ['./exemption_common.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionCommonComponent extends ExemptionsComponent {

  @Input() exemption: Exemption

  attachmentRequired = attachmentRequired;

  getTooltipAttachment = getTooltipAttachment;

  resetOnBehalfOfOther () {
    this.exemption.onBehalfOfOther = '';
  }

  protected readonly Array = Array;
}
